import React from 'react';
import PropTypes from 'prop-types';
import DataTablePagination from './DataTablePagination';

const DataTableFooter = (props) => {
    const { columns, className, ...other } = props;

    return (
        <tfoot className={`data-table__footer data-table__footer--${className}`}>
            <tr>
                <td className="data-table__footer-cell" colSpan={columns.length}>
                    <DataTablePagination {...other} />
                </td>
            </tr>
        </tfoot>
    );
};

DataTableFooter.propTypes = {
    columns: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    isLoading: PropTypes.bool.isRequired,
    onPageChange: PropTypes.func.isRequired,
    onNumberOfItemsChange: PropTypes.func.isRequired,
    page: PropTypes.shape({
        count: PropTypes.number,
        number: PropTypes.number,
    }).isRequired,
    className: PropTypes.string.isRequired,
};
export default DataTableFooter;
